import { __assign } from "tslib";
import * as React from 'react';
import { Button } from 'reactstrap';
import { BubbleCommand } from '../_shared/constants';
import { BubbleChannel } from '../client/src/modules/_core/components/BubbleChannel';
import { HeaderClass } from '../client/src/modules/_core/components/Header/Header';
import { PageHome } from '../client/src/modules/_core/components/PageHome/PageHome';
import { config } from '../client/src/modules/_core/config';
import { url } from '../client/src/modules/_core/url';
import { I18nMsgNs } from '../client/src/modules/_core/utils/i18n-helpers';
import { elementAttrs } from '../client/src/modules/_core/utils/element-id';
import { TextMessageClass } from '../client/src/modules/chat/components/Messages/TextMessage';
import { dataLayerPush } from './utils';
import { headerOnCloseHandler } from './born-digital/externals-fns/header-close-handler';
import { BytesizeIcon } from '../client/src/modules/_core/components/BytesizeIcon';
import { injectIntl } from 'react-intl';
export var initializeExternals = function (clientConfig) {
    var B = config.css.B('-header');
    var isFullscreen = false;
    PageHome.getInitialRoute = function () { return url.CHAT(); };
    TextMessageClass.messageTimestampFormatter = function (message, cmp) {
        var d = new Date(message.created);
        var pad = function (v) { return (v < 10 ? "0".concat(v) : v); };
        return pad(d.getHours()) + ':' + pad(d.getMinutes());
    };
    HeaderClass.rendererLeftBox = function (cmp) {
        var toggleFullscreen = function (e) {
            e.preventDefault();
            isFullscreen = !isFullscreen;
            BubbleChannel.postCommand(BubbleCommand.OPEN_FULLSCREEN_TOGGLE);
        };
        return (React.createElement(React.Fragment, null)
        // <button
        //     className={`${B}__boxbutton fullscreen-icon ${
        //         isFullscreen ? 'fullscreen-on' : ''
        //     }`}
        //     onClick={toggleFullscreen}
        // >
        //     {/* <BytesizeIcon name="fullscreen" size="regular" thickness="medium" /> */}
        // </button>
        );
    };
    HeaderClass.rendererRightBox = function (cmp) {
        var RightBox = function (_a) {
            var intl = _a.intl;
            var B = config.css.B('-header');
            return (React.createElement(React.Fragment, null, clientConfig.SHOW_X && React.createElement("button", __assign({}, elementAttrs('header', 'close'), { className: "".concat(B, "__boxbutton close-icon"), onClick: function () {
                    var messages = cmp.props.getThreadMessages(cmp.props.threadId);
                    return messages.some(function (_a) {
                        var is_bot = _a.is_bot;
                        return !is_bot;
                    }) ? headerOnCloseHandler(cmp, intl) : headerOnCloseHandler(cmp, intl, true);
                } }),
                React.createElement(BytesizeIcon, { name: "close", size: "small", thickness: "medium" }))));
        };
        var RightBoxWithIntl = injectIntl(RightBox);
        return React.createElement(RightBoxWithIntl, null);
    };
    PageHome.rendererMain = function (cmp) {
        var Msg = I18nMsgNs('PageHome');
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "gaid-page-home__texts" },
                React.createElement("h1", null,
                    React.createElement(Msg, { id: "startWelcome" })),
                React.createElement("p", null,
                    React.createElement(Msg, { id: "startWelcomeDesc" }))),
            React.createElement("div", { className: "gaid-page-home__buttonwrap" },
                React.createElement(Button, __assign({}, elementAttrs('page-home', 'start-new'), { color: "primary", onClick: function () {
                        PageHome.onStartNewClick();
                        // https://docs.google.com/spreadsheets/d/1WDsoIs_v0Dc1sOASo0k0ugUbb2i7o3QaJj6NyZisKAQ/edit#gid=0
                        dataLayerPush({
                            eventAction: 'RedButton',
                            eventLabel: 'Zacat Chat',
                        });
                    } }),
                    React.createElement(Msg, { id: "startNew" })),
                React.createElement("div", { className: "gaid-page-home__footer" }, "powered by Born Digital"))));
    };
};
